var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Support") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.6 13.9v1.7h16.8v17.6c-0.1 3.1-2.7 5.6-5.8 5.6h-25.2c-3.1-0.1-5.6-2.7-5.6-5.8v-2.8h-1.6v3c0.1 4 3.4 7.2 7.5 7.2h7.2l-1.2 5h-2.7v1.6h18.3v-1.6h-2.7l-1.2-5h7.5c4-0.1 7.2-3.4 7.2-7.5v-19h-18.5zm-6.3 31.5l1.2-5h7l1.2 5h-9.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25 9.3c-1.1-5.4-5.9-9.3-11.4-9.3-5.6 0-10.4 3.9-11.5 9.3-1.2 0.2-2.1 1.2-2.1 2.5v1.3c0 0.2 0.2 0.4 0.4 0.4s0.4-0.2 0.4-0.4v-1.3c0-0.9 0.8-1.7 1.7-1.7h0.8v8.2h-0.8c-0.9 0-1.7-0.8-1.7-1.7v-1.5c0-0.2-0.2-0.4-0.4-0.4s-0.4 0.2-0.4 0.4v1.5c0 1.4 1.1 2.5 2.5 2.5h0.9c0.2 0 0.8 0 0.8-0.3v-9.2c0-0.3-0.6-0.3-0.8-0.3h-0.5c1.1-5 5.5-8.5 10.6-8.5s9.5 3.5 10.6 8.5h-0.5c-0.5 0-0.9 0-0.9 0.3v9.2c0.1 0.5 0.9 0.3 0.9 0.3h0.5c-0.8 3.7-4.1 6.3-7.9 6.4-0.2-0.5-0.7-0.9-1.2-0.9h-3-0.2c-0.7 0.1-1.2 0.7-1.1 1.4s0.7 1.2 1.4 1.1h3c0.5 0 1-0.3 1.2-0.9 4.3 0 7.9-3 8.7-7.2 1.2-0.2 2.2-1.2 2.2-2.5v-4.8c0-1.2-0.9-2.2-2.2-2.4zm-9.9 16.8h-3c-0.6 0-0.6-0.7 0-0.7h3c0.6 0 0.6 0.7 0 0.7zm9.4-7.9h-0.8v-8.1h0.8c0.9 0 1.7 0.8 1.6 1.7v4.8c0.1 0.9-0.7 1.6-1.6 1.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.4 13.5v0.2c0.1 2.4 2 4.4 4.4 4.4h0.2c2.4-0.2 4.3-2.2 4.2-4.7h1v0.2c0 3-2.4 5.4-5.4 5.5h-0.2c-3-0.2-5.3-2.7-5.2-5.7l1 0.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.774f8669acb4157a6166b9b2376e9255.svg";
export { ForwardRef as ReactComponent };